const state = {
    userInformation :'',
    // isLogin:false

};

const mutations = {
    set_userInformation(state,val){
        state.userInformation = val;

    },
  /*  set_isLogin(state,val){
        state.userInformation = val;
    }*/


};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
